document.addEventListener('DOMContentLoaded', function () {
  var radios = document.querySelectorAll('.option input[type="radio"]');

  radios.forEach(function (radio) {
    radio.addEventListener('click', function () {
      document.querySelectorAll('.option').forEach(function (div) {
        div.classList.remove('active');
      });
      if (this.checked) {
        selected_variant = this.id;
        this.parentNode.classList.add('active');
        // this.closest('.card__actions-overlay').style.setProperty('display', 'block');
      }
    });
  });

  var add_buttons = document.querySelectorAll('.quick-add__submit');
  var variant_input;
  add_buttons.forEach(function (button) {
    button.addEventListener('click', function () {
      var form = this.closest('form');
      var variant_input = form.querySelector('input[name="id"]');
    });
  });
});
